export default "__VITE_ASSET__DAqbp14o__"